// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ppropEntity from './entities/pprop.json';
import ppropMenu from '../pages/pprop/menu.json';
import ppropFullForm from '../pages/pprop/forms/full.json';
import ppropContextForm from '../pages/pprop/forms/context.json';
import ppropMiniForm from '../pages/pprop/forms/mini.json';
import ppropLookupForm from '../pages/pprop/forms/lookup.json';
import ppropTableView from '../pages/pprop/views/table.json';
import ppropStagesView from '../pages/pprop/views/stages.json';
import ppropCardsView from '../pages/pprop/views/cards.json';
import ppropInlineView from '../pages/pprop/views/inline.json';
import ppropBacklogView from '../pages/pprop/views/backlog.json';
import ppropSplitView from '../pages/pprop/views/split.json';
import ppropCalendarView from '../pages/pprop/views/calendar.json';
import ppropDashboardView from '../pages/pprop/views/dashboard.json';

/** Тип запису «Пропозиція проєкту» зі сторінками пакета: меню, форми та подання з pages/pprop/. */
export const ppropDefinition: IRecordTypeDefinition = {
  ...ppropEntity,
  views: assembleViewSet({
      table: ppropTableView,
      stages: ppropStagesView,
      cards: ppropCardsView,
      inline: ppropInlineView,
      backlog: ppropBacklogView,
      split: ppropSplitView,
      calendar: ppropCalendarView,
      dashboard: ppropDashboardView,
  }),
  form: ppropFullForm,
  forms: { full: ppropFullForm, context: ppropContextForm, mini: ppropMiniForm, lookup: ppropLookupForm },
  menu: ppropMenu,
} as IRecordTypeDefinition;
